// extracted by mini-css-extract-plugin
export default {"nolink":"LinkViewer_nolink__s6HO9","details":"LinkViewer_details__BTBZW"};